import { useLanguage } from '../../i18n/LanguageContext';

/** A status chip: `dealer.status.<STATUS>` text, colour by status. */
export default function StatusChip({ status }: { status: string | null | undefined }) {
  const { t } = useLanguage();
  if (!status) return null;
  const key = `dealer.status.${status}`;
  const label = t(key) === key ? status : t(key);
  return <span className={`dealer-chip dealer-chip--${status.toLowerCase()}`}>{label}</span>;
}
